module.exports = __webpack_public_path__ + "static/img/xljs.8e1d704.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xljs.png
// module id = ENmb
// module chunks = 0